import {
    FETCH_COMPANIES_BEGIN,
    FETCH_COMPANIES_ERROR,
    FETCH_COMPANIES_SUCCESS,
    FETCH_COMPANY_AVAILABLE_LANGUAGES_BEGIN,
    FETCH_COMPANY_AVAILABLE_LANGUAGES_SUCCESS,
    FETCH_OPERATOR_TINY_COMPANIES_BEGIN,
    FETCH_OPERATOR_TINY_COMPANIES_SUCCESS,
    FETCH_SELECTED_COMPANIES_BEGIN,
    FETCH_SELECTED_COMPANIES_SUCCESS,
    FETCH_TINY_COMPANIES_BEGIN,
    FETCH_TINY_COMPANIES_ERROR,
    FETCH_TINY_COMPANIES_SUCCESS,
    FETCH_TINY_COMPANIES_WITH_OPERATOR_BEGIN,
    FETCH_TINY_COMPANIES_WITH_OPERATOR_ERROR,
    FETCH_TINY_COMPANIES_WITH_OPERATOR_SUCCESS,
    SAVE_COMPANY_BEGIN,
    SAVE_COMPANY_ERROR,
    SAVE_COMPANY_SUCCESS
} from '../actions/companyActions';

const defaultCompaniesState =  {
	companies: [],
	pagination: {},
	loading: false,
	error: null
};

const defaultTinyCompaniesState =  {
	tinyCompanies: [],
	pagination: {},
	loading: false,
	error: null
};

const defaultTinyCompaniesWithOperatorState =  {
	tinyCompanies: [],
	pagination: {},
	loading: false,
	error: null
};

const defaultCompanyState =  {
	company: {},
	loading: false,
	error: null
};

const defaultCompanyLanguagesState = {
	companyLanguages: [],
	loading: false,
};

const defaultOperatorTinyCompaniesState = {
	operatorTinyCompanies: [],
	loading: false,
};

export const companiesReducer = (state = defaultCompaniesState, action)  => {
	switch (action.type) {
	case FETCH_COMPANIES_BEGIN:
		return {
			...state,
			loading: true,
			error: null
		};

	case FETCH_COMPANIES_SUCCESS:
		return {
			...state,
			loading: false,
			companies: action.payload.companies,
			pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};

	case FETCH_COMPANIES_ERROR: {
		return {
			...state,
			loading: false,
			companies: [],
			error: action.payload.error
		};
	}

	case FETCH_SELECTED_COMPANIES_BEGIN:
		return {
			...state,
			loading: true,
		};

	case FETCH_SELECTED_COMPANIES_SUCCESS: {
		return {
			...state,
			loading: false,
			companies: action.payload.selectedCompanies,
		};
	}

	default:
		return state;
	}
};

export const tinyCompaniesReducer = (state = defaultTinyCompaniesState, action)  => {
	switch (action.type) {
		case FETCH_TINY_COMPANIES_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			};

		case FETCH_TINY_COMPANIES_SUCCESS:
			return {
				...state,
				loading: false,
				tinyCompanies: action.payload.tinyCompanies,
				pagination: {
					totalElements: action.payload.totalElements
				},
			};

		case FETCH_TINY_COMPANIES_ERROR: {
			return {
				...state,
				loading: false,
				tinyCompanies: [],
				error: action.payload.error
			};
		}

		default:
			return state;
	}
};

export const tinyCompaniesWithOperatorReducer = (state = defaultTinyCompaniesWithOperatorState, action)  => {
	switch (action.type) {
		case FETCH_TINY_COMPANIES_WITH_OPERATOR_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			};

		case FETCH_TINY_COMPANIES_WITH_OPERATOR_SUCCESS:
			return {
				...state,
				loading: false,
				tinyCompanies: action.payload.tinyCompanies,
				pagination: {
					totalElements: action.payload.totalElements
				},
			};

		case FETCH_TINY_COMPANIES_WITH_OPERATOR_ERROR: {
			return {
				...state,
				loading: false,
				tinyCompanies: [],
				error: action.payload.error
			};
		}

		default:
			return state;
	}
};

export const addCompanyReducer = (state = {}, action) => {
	switch (action.type) {
	case SAVE_COMPANY_BEGIN:
		return {
			...state,
			loading: true,
			error: null
		};

	case SAVE_COMPANY_SUCCESS:
		return {
			...state,
			loading: false,
			company: action.payload.company,
		};

	case SAVE_COMPANY_ERROR:
		return {
			...state,
			loading: false,
			error: action.payload.error
		};
	default:
		return state;
	}
};

export const companyLanguageReducer = (state = defaultCompanyLanguagesState, action) => {
	switch (action.type) {
		case FETCH_COMPANY_AVAILABLE_LANGUAGES_BEGIN:
			return {
				...state,
				loading: true
			};

		case FETCH_COMPANY_AVAILABLE_LANGUAGES_SUCCESS:
			return {
				...state,
				loading: false,
				companyLanguages: action.payload.companyLanguages,
			};
		default:
			return state;
	}
};

export const operatorTinyCompaniesReducer = (state = defaultOperatorTinyCompaniesState, action) => {
	switch (action.type) {
		case FETCH_OPERATOR_TINY_COMPANIES_BEGIN:
			return {
				...state,
				loading: true
			};

		case FETCH_OPERATOR_TINY_COMPANIES_SUCCESS:
			return {
				...state,
				loading: false,
				operatorTinyCompanies: action.payload.operatorTinyCompanies,
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/company.js